// login
export const LOGIN_ADMIN = "LOGIN_ADMIN";

//LogOut_admin
export const LOGOUT_ADMIN = "LOGOUT_ADMIN";

// get profile
export const PROFILE_ADMIN = "PROFILE_ADMIN";

//  admin profile update
export const UPDATE_PROFILE = "UPDATE_PROFILE";

// Change Password
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";

// Update Image Profile
export const UPDATE_IMAGE_PROFILE = "UPDATE_IMAGE_PROFILE";

//Update Password
export const UPDATE_ADMIN_PASSWORD = "UPDATE_ADMIN_PASSWORD"

export const SIGNUP_ADMIN = "SIGNUP_ADMIN";

// MFA Types
export const SET_MFA_REQUIRED = "SET_MFA_REQUIRED";
export const SET_MFA_STATUS = "SET_MFA_STATUS";
export const SET_MFA_QR_CODE = "SET_MFA_QR_CODE";
export const CLEAR_MFA_DATA = "CLEAR_MFA_DATA";



